import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class ScholarshipSessionDto extends EpimsBaseEntityDto {
	@IsNotEmpty() ScholarshipSessionId: string;
	@IsNotEmpty() ScholarshipSessionName: string;
}
